module.exports = __webpack_public_path__ + "../static/img/base_vrp.0103614c.png";